import React, {FC,useState,useEffect,useContext} from 'react'
import {fetchProjects} from '../../../app/helpers/remoteData'
import {CableCampaign} from './CableWrapper'
import {Stat} from './Stat'
import {RemoteDataContext} from '../../providers/RemoteDataProvider'
import {ClientContext} from '../../providers/ClientProvider'

type Props = {
    archived: boolean
}

const Stats: FC<Props> = ({archived}) => {
    const { cables, setCables } = useContext(RemoteDataContext)
    const { client } = useContext(ClientContext)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        const fetchCableProjects = async () => {
            if (client.cable) {
                setIsLoading(true)
                const _projects: CableCampaign[] = await fetchProjects(client.cable, archived)
                console.log('PROJECTS', _projects)
                setCables(_projects)
                setIsLoading(false)
            }
        }
        fetchCableProjects()
    }, [setCables, client.cable, archived])

    return (
        <div className='row gy-5 g-xl-8'>
            {
                isLoading ? 
                <div className="text-center pt-5">
                    <p>Stats are loading...</p>
                    <div className="spinner-border spinner-border-sm" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
                :
                <>
                    {
                        cables.length > 0 ?
                            <>
                                {
                                    cables.map((x, i) => <Stat key={`stat-${i}`} data={x} />)
                                }
                            </>
                        :
                        null
                    }
                </>
            }
        </div>
    )
}

export {Stats}
